import { render } from "./EditorBoxAppearance.vue?vue&type=template&id=3c112442&scoped=true"
import script from "./EditorBoxAppearance.vue?vue&type=script&lang=js"
export * from "./EditorBoxAppearance.vue?vue&type=script&lang=js"

import "./EditorBoxAppearance.vue?vue&type=style&index=0&id=3c112442&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c112442"

export default script